<template>
  <div class="judging-program-view">
    <!-- VideoBox -->
  <div class="fixed-video-box" ref="fixedVideoBox">
    <div class="card box_component" id="cardVideoTutorial">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5>
              {{ $t('judging_program.round_video_box.card_header') }}
              <span v-if="athleteId"> - {{ athleteFullName.name +' '+ athleteFullName.surname }}</span>
              <span v-if="competitionDetails && competitionDetails.rounds && competitionDetails.rounds.length && lastRound">
                - Round Nº: {{ lastRound.round_number + 1 }}
              </span>
              <span v-else>
                <template v-if="athleteId">
                  - Round Nº: 1
                </template>
              </span>
            </h5>
            <button
                class="btn btn-link"
                type="button"
                @click="toggleCollapse();"
                :aria-expanded="isExpanded ? 'true' : 'false'"
            >
                <i v-if="isExpanded" class="fas fa-minus-circle fa-lg text-secondary"></i>
                <i v-else class="fas fa-plus-circle fa-lg text-secondary"></i>
            </button>
        </div>
        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div v-if="isExpanded" key="content" class="box">
                <div class="card-body p-1" >
            <div class="container text-center">
                <div class="row">
                    <div class="col-12 p-0">
                        <div v-if="!videoUrl">
                            <div v-if="!videoUrl && !round_view" class="mb-3">
                                <label for="videoInput" class="form-label">{{ $t('judging_program.round_video_box.input_label') }}</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('judging_program.round_video_box.placeholder')"
                                        id="videoInput"
                                        v-model="videoLink"
                                        :disabled="videoUrl !== null"
                                    />
                                    <button
                                        class="btn btn-warning"
                                        @click="saveVideoLink"
                                        :disabled="videoUrl !== null"
                                    >
                                        <i class="fa-solid fa-cloud-arrow-up"></i>
                                        {{ $t('judging_program.round_video_box.button_save') }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="round_view" class="mb-3">
                               <p>{{ $t('judging_program.round_video_box.not_video') }}</p>
                            </div>
                        </div>
                        <div v-else>
                            <YoutubePlayer :video-url="videoUrl" @delete-video-url="deleteVideoUrlComponent()" @refresh-box-size="adjustContentHeight()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
            </div>
        </transition>
    </div>
  </div>
  <div class="scrollable-content" ref="scrollableContent">
    <!-- SearchBox -->
    <div v-if="!round_view" class="card box_component" id="cardSearchTutorial">
        <h5 class="card-header">
            {{ $t('judging_program.trick_selector_box.card_header') }}
            <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                 {{ this.modeProgram === 1 ? $t('judging_program.trick_selector_box.title_opcion_1') :
                this.modeProgram === 2 ? $t('judging_program.trick_selector_box.title_opcion_2') :
                    this.modeProgram === 3 ? $t('judging_program.trick_selector_box.title_opcion_3') :
                    this.modeProgram === 4 ? $t('judging_program.trick_selector_box.title_opcion_4') :
                        'ERROR RULES' }}
            </span>
        </h5>
        <div class="card-body p-1" >
            <div class="container text-center">
                <div class="row">
                    <div class="col-12 py-2 px-0">
                        <SearchBox
                            ref="searchFocus"
                            :tricks="tricks"
                            :selectedListTricks="selectedListTricks"
                            :validatedTricks="validatedTricks"
                            :trickEdit="trickEdit"
                            :trickEditIndex="trickEditIndex"
                            :trickValidatedEdit="trickValidatedEdit"
                            :trickValidatedEditIndex="trickValidatedEditIndex"
                            :trickValidatedEditSubIndex="trickValidatedEditSubIndex"
                            @update-selected-tricks="handleUpdateSelectedTricks"
                            @update-validated-tricks="handleUpdateValidatedTricks"

                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- SelectedBox -->
    <div v-if="!round_view" class="card box_component" :style="trickEdit || trickValidatedEdit ? { opacity: '0.3' } : {}" id="cardSelectedTutorial">
        <h5 class="card-header position-relative">
            {{ $t('judging_program.selected_tricks_box.card_header') }}
            <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                {{ selectedListTricks.length || 0 }}
            </span>
        </h5>
        <div class="card-body px-0" >
            <div class="container text-center">
                <div class="row">
                    <div class="col-12 py-2 px-0">
                        <SelectedBox
                            :selectedListTricks="selectedListTricks"
                            :validatedTricks="validatedTricks"
                            :comboCount="comboCount"
                            :comboValidatedEditIndex="comboValidatedEditIndex"
                            @update-validated-tricks="handleUpdateValidatedTricks"
                            @clear-selected-tricks="clearSelectedTricks"
                            @update-tricks-selected="updateTrickSelected"
                            @delete-trick-selected="deleteTrickSelected"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ValidatedBox -->
    <div class="card box_component" :style="trickEdit || trickValidatedEdit || comboValidatedEditIndex !== null ? { opacity: '0.3' } : {}" id="cardValidatedTutorial">
        <h5 class="card-header">
            <span>{{ $t('judging_program.validated_tricks_box.card_header') }}</span>
            <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                {{ this.totalTricks || 0 }}
             </span>
        </h5>
        <div class="card-body px-0">
            <div class="container text-center">
                <div class="row">
                    <div class="col-12 p-0">
                        <ValidationBox
                            :validatedTricks="validatedTricks"
                            @update-validated-tricks="handleUpdateValidatedTricks"
                            @update-trick-validated="updateTrickValidated"
                            @delete-trick-validated="deleteTrickValidated"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- TotalBox -->
    <div class="card box_component" id="cardTotalsTutorial">
        <h5 class="card-header">
            <span>{{ $t('judging_program.totals_tricks_box.card_header') }}</span>
        </h5>
        <div class="card-body px-0">
            <div class="container text-center">
                <div class="row">
                    <!-- Scoring Box -->
                    <div class="col-4">
                        <div class="bar-item total-score-bar">
                            {{ $t('judging_program.totals_tricks_box.total_score') }}: <b>{{ this.totalScore || 0 }}</b>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="bar-item total-variety-bar">
                            {{ $t('judging_program.totals_tricks_box.total_variety') }}: <b>{{ this.countUniqueTrick.total || 0 }}</b>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="bar-item total-style-bar">
                            {{ $t('judging_program.totals_tricks_box.total_style') }}: <b>{{ this.totalScorePrint.style }}</b>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="total-bar">
                            {{ $t('judging_program.totals_tricks_box.total_scores') }}:<b> {{ parseFloat(this.totalScorePrint.score.toFixed(2)) }}</b>
                        </div>
                    </div>
                </div>
                <div  class="row mt-3">
                    <div v-if="round_update || round_view || athleteId" class="col-6">
                        <button @click="cancelEditRound" class="btn btn-danger">
                            <i class="fas fa-cancel"></i>
                            {{ $t('judging_program.totals_tricks_box.cancel') }}
                        </button>
                    </div>
                    <div v-else class="col-6">
                        <button @click="clearLocalStorage" class="btn btn-danger">
                            <i class="fas fa-trash-alt"></i>
                            {{ $t('judging_program.totals_tricks_box.clear_all') }}
                        </button>
                    </div>
                    <div v-if="round_update"  class="col-6">
                        <button @click="updateScoreList" class="btn btn-warning">
                            <i class="fas fa-save"></i>
                            {{ $t('judging_program.totals_tricks_box.update_btn') }}
                        </button>
                    </div>
                    <div v-if="!round_update && !round_view" class="col-6">
                        <button @click="storageScoreList" :disabled="!this.validatedTricks.length" class="btn btn-warning">
                            <i class="fas fa-save"></i>
                            {{ $t('judging_program.totals_tricks_box.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  </div>
    <ConfirmationModal
        ref="confirmationModal"
        :message="modalMessage"
        :showCancel="showCancel"
        :showRuleSelector="false"
        :ruleOptions="[]"
        :showNameInput="false"
        :initialRule="''"
        :initialName="''"
        @confirmed="handleConfirmed"
        @canceled="cancelModal"
    />
    <loading-modal ref="loadingModal"></loading-modal>
</template>

<script>
import SearchBox from "@/components/judging/SearchBox.vue";
import SelectedBox from "@/components/judging/SelectedBox.vue";
import ValidationBox from "@/components/judging/ValidationBox.vue";
import ConfirmationModal from "@/components/competitions/ConfirmationModal.vue";
import { secureStorage } from "@/services/secureStorage";
import LoadingModal from "@/services/LoadingModal.vue";
import { normalizeTricklistEntries, readCachedTricklist, writeCachedTricklist } from "@/lib/tricklistVersionCache";
import YoutubePlayer from '@/services/YoutubePlayer.vue';

const SCORING_LESS_25 = 0.75;
const SCORING_LESS_50 = 0.5;
const SCORING_LESS_75 = 0.25;
const SCORING_DUB_20 = 0.8;
const SCORING_DUB_50 = 0.5;
const SCORING_DUB_80 = 0.2;
const SCORING_STYLE_PLUS_1 = 1.05;
const SCORING_STYLE_PLUS_2 = 1.10;
const SCORING_STYLE_PLUS_4 = 1.15;
const SCORING_STYLE_PLUS_7 = 1.20;
const SCORING_COMBO_PLUS = 1.5;
const SCORING_COMBO_PLUS_FEET = 1.65;
const SCORING_COMBO_PLUS_6 = 2;
const SCORING_COMBO_PLUS_6_FEET = 2.2;
export default {
    name: "JudgingProgramBox",
    data() {
        return {
            trickEdit: null,
            trickEditIndex: null,
            trickValidatedEdit: null,
            trickValidatedEditIndex: null,
            trickValidatedEditSubIndex: null,
            comboValidatedEditIndex: null,
            tricks: JSON.parse(secureStorage.getItem('tricks')) || [],
                        activeTricklistVersionId: null,
            selectedListTricks:  JSON.parse(secureStorage.getItem('selectedTricks')) || [],
            validatedTricks: JSON.parse(secureStorage.getItem('validatedTricks')) || [],
            comboSelected: [],
            comboCount: JSON.parse(localStorage.getItem('comboCount')) || 1,
            modeProgram: JSON.parse(localStorage.getItem('selectedOption')) || 4,
            totalScorePrint : {
                'style' : '0%',
                'score' : 0,
            },
            round_update : this.$store.state.roundIdToUpdate,
            round_view : this.$store.state.roundIdToView,
            videoLink: null,
            videoUrl: JSON.parse(secureStorage.getItem('videoUrl')) || null,
            isExpanded: true,
            athleteId: null,
            athleteFullName: [],
            competitionDetails: JSON.parse(secureStorage.getItem('competitionIdToView')) || [],
                        lastRound: null,
                        pendingConfirmResolver: null,
                        showCancel: false,
                        modalMessage: ""

          // videoUrl: 'https://www.youtube.com/watch?v=qUo7Wnlm260',
            // videoUrl: 'https://www.youtube.com/watch?v=g_Ms0VuN0K4',
        };
    },
    computed: {
        totalScore() {
            const calculateScore = (tricks) => {
                return tricks.reduce((total, trick) => {
                    if (Array.isArray(trick.body)) {
                        total += calculateScore(trick.body);
                    } else {
                        total += trick.score || 0;
                    }
                    return total;
                }, 0);
            };
            return parseFloat(calculateScore(this.validatedTricks).toFixed(2));
        },
        totalTricks() {
            const calculateTricks = (tricks) => {
                return tricks.reduce((total, trick) => {
                    if (Array.isArray(trick.body)) {
                        total += calculateTricks(trick.body);
                    } else {
                        total += 1 || 0;
                    }
                    return total;
                }, 0);
            };
            return calculateTricks(this.validatedTricks);
        },
        countUniqueTrick() {
            const result = {
                total: 0,
                counter: [],
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    const key = this.getKeyForTrick(trick);
                    if (key !== undefined) {
                        if (result.counter.find(existingKey => existingKey === key) === undefined) {
                            result.counter.push(key);
                            result.total = (result.total || 0) + 1;
                        }
                    }
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }
                });
            };
            countTricks(this.validatedTricks);
            return result;
        },
    },
    mounted() {
        // this.getTrickListUpdated();
        this.calculateTotalWithRules();
        window.addEventListener('tricks:updated', this.getTrickListUpdated);
        if (this.$store.state.roundIdToUpdate){
            this.editRound(this.$store.state.roundIdToUpdate);
        }
        if (this.$store.state.athleteId){
          this.athleteId = this.$store.state.athleteId;
          this.checkName(this.athleteId);
          this.fetchCompetitionDetails(this.$store.state.competitionIdToView);
        }
        if (this.$store.state.roundIdToView){
            this.viewRound(this.$store.state.roundIdToView);
        }
        // window.addEventListener('resize', this.adjustContentHeight);

    },
    beforeUnmount() {
            window.removeEventListener('tricks:updated', this.getTrickListUpdated);
      // window.removeEventListener('resize', this.adjustContentHeight);
    },
    watch: {
        validatedTricks() {
            this.calculateTotalWithRules()
        },
        competitionDetails(){
            this.findLastRound()
        },
        immediate: true
    },
    components: {
        SearchBox,
        SelectedBox,
        ValidationBox,
        ConfirmationModal,
        LoadingModal,
        YoutubePlayer
    },
    methods: {
        /*Components*/
        clearSelectedTricks() {
            this.selectedListTricks = [];
            this.comboValidatedEditIndex= null;
            localStorage.removeItem('selectedTricks');
        },
        handleUpdateSelectedTricks(trickEditIndex,updatedTricks) {
            if (trickEditIndex !== null && trickEditIndex !== undefined && trickEditIndex >= 0 && trickEditIndex < this.selectedListTricks.length) {
                this.selectedListTricks.splice(trickEditIndex, 1, updatedTricks);
                this.trickEdit= null;
                this.trickEditIndex= null;
            } else {
                // Si trickEditIndex no tiene un valor válido, agregar el truco al final del array
                this.selectedListTricks = [...this.selectedListTricks, updatedTricks];
            }
            secureStorage.setItem('selectedTricks', JSON.stringify(this.selectedListTricks));
        },
        handleUpdateValidatedTricks(trickValidatedEditIndex, trickValidatedEditSubIndex, updatedTricks) {
            if (trickValidatedEditIndex !== null && trickValidatedEditIndex !== undefined && trickValidatedEditIndex >= 0 && trickValidatedEditIndex < this.validatedTricks.length) {
                if (trickValidatedEditSubIndex !== null && trickValidatedEditSubIndex !== undefined) {
                    const trickToUpdate = this.validatedTricks[trickValidatedEditIndex].body[trickValidatedEditSubIndex];
                    if (trickToUpdate) {
                        Object.assign(trickToUpdate, updatedTricks);
                        this.calculateTotalWithRules();
                    }
                } else {
                    this.validatedTricks[trickValidatedEditIndex] = updatedTricks;
                    this.calculateTotalWithRules();
                }

                this.trickValidatedEdit = null;
                this.trickValidatedEditIndex = null;
                this.trickValidatedEditSubIndex = null;
            } else {
                // Si trickEditIndex no tiene un valor válido, agregar el truco al final del array
                this.validatedTricks = [...this.validatedTricks, updatedTricks];
                this.calculateTotalWithRules();
            }
            secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
        },
        deleteTrickSelected(index) {
            // Actualizar el array sin mutar directamente la prop
            this.selectedListTricks = this.selectedListTricks.filter((_, i) => i !== index);
            secureStorage.setItem('selectedTricks', JSON.stringify(this.selectedListTricks));
        },
        updateTrickSelected(index){
            this.trickEdit = { ...this.selectedListTricks[index] };
            this.trickEditIndex = index;
            this.$refs.searchFocus.focus();
            this.scrollToElement('cardSearchTutorial');
            },
        deleteTrickValidated(index, subIndex) {
            if (index >= 0 && index < this.validatedTricks.length) {
                if (subIndex >= 0){
                    this.validatedTricks[index].body = this.validatedTricks[index].body.filter((trick, i) => {
                        const shouldKeep = i !== subIndex;
                        if (!shouldKeep) {
                            this.$nextTick(() => {
                                if (this.validatedTricks[index].body.length === 1){
                                    // Mover el elemento 0 del body a validatedTricks
                                    const trickToMove = this.validatedTricks[index].body[0];
                                    delete trickToMove.combo_id;
                                    this.validatedTricks[index] = trickToMove;
                                    delete this.validatedTricks[index].body;
                                    delete this.validatedTricks[index].header;
                                    this.calculateTotalWithRules();
                                }else{
                                    this.validatedTricks[index].header.total_tricks_combo = this.validatedTricks[index].body.length ;
                                    this.validatedTricks[index].header.total_score = this.validatedTricks[index].body.reduce((total, trick) => total + trick.score, 0);
                                }
                            });
                        }
                        return shouldKeep;
                    });
                }else{
                    this.validatedTricks = this.validatedTricks.filter((_, i) => i !== index);
                }
                this.$nextTick(() => {
                    secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
                });

            }
        },
        updateTrickValidated(index, subIndex){
            if (index >= 0 && index < this.validatedTricks.length) {
                if (subIndex >= 0){
                    this.trickValidatedEdit = { ...this.validatedTricks[index].body[subIndex] };
                    this.trickValidatedEditIndex = index;
                    this.trickValidatedEditSubIndex = subIndex;
                }else{
                    if ('body' in this.validatedTricks[index]){
                        this.selectedListTricks = this.validatedTricks[index].body;
                        this.comboValidatedEditIndex = index;
                    }else{
                        this.trickValidatedEdit = { ...this.validatedTricks[index] };
                        this.trickValidatedEditIndex = index;
                    }
                }
                this.$nextTick(() => {
                    this.$refs.searchFocus.focus();
                    this.scrollToElement('cardSearchTutorial');
                    secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
                });
            }

        },
        async clearLocalStorage() {
            const isConfirmed = await this.confirmWithModal('Are you sure you want to clear all validated tricks?');

            if (isConfirmed) {
                this.validatedTricks = [];
                this.selectedListTricks = [];
                this.comboSelected = [];
                this.comboCount = 1;
                this.totalScorePrint = {
                    'style' : '0%',
                    'score' : 0,
                };
                localStorage.removeItem('validatedTricks');
                localStorage.removeItem('selectedTricks');
                localStorage.removeItem('comboCount');
                this.$emit('clear-validated-tricks');
            }
        },
        cancelEditRound(){
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.comboCount = 1;
            this.totalScorePrint = {
                'style' : '0%',
                'score' : 0,
            };
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');
            this.videoUrl=null;
            this.$emit('clear-validated-tricks');
            this.$store.commit('resetRoundIdToUpdate');
            this.$store.commit('resetRoundIdToView');
            this.$store.commit('resetAthleteId');
            if (this.$store.state.competitionIdToView != null){
              this.round_update = false;
              this.round_view = false;
              this.$router.push('/competitionDetails');
            }else{
              this.$store.commit('resetCompetitionIdToView');
              this.round_update = false;
              this.round_view = false;
              this.$router.push('/home');
            }
        },
        async storageScoreList() {
            const isConfirmed = await this.confirmWithModal(this.$t('training.modal.save_new_round_confirm'));
            if (isConfirmed) {
                try {
                    this.showLoading();
                    const response = await this.$axios.post("/store", {
                        modeProgram: this.modeProgram,
                        competitionDetails: this.competitionDetails && Object.keys(this.competitionDetails).length ? this.competitionDetails.id : null,
                        athleteId: this.athleteId,
                        validatedTricks: this.validatedTricks,
                        totalScorePrint: this.totalScorePrint,
                        countUniqueTrick: this.countUniqueTrick.total,
                        totalScore: this.totalScore,
                        videoUrl: this.videoUrl,
                    }, {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.getToken}`,
                        },
                    });
                    if (response.status === 200){
                        this.validatedTricks = [];
                        this.selectedListTricks = [];
                        this.comboSelected = [];
                        this.athleteId = null;
                        this.athleteFullName = [];
                        this.competitionDetails = [];
                        this.comboCount = 1;
                        this.totalScorePrint = {
                            'style' : '0%',
                            'score' : 0,
                        };
                        localStorage.removeItem('validatedTricks');
                        localStorage.removeItem('selectedTricks');
                        localStorage.removeItem('comboCount');
                        localStorage.removeItem('videoUrl');
                        localStorage.removeItem('athleteId');
                        this.$emit('clear-validated-tricks');
                        this.hideLoading();
                      if (this.$store.state.competitionIdToView != null){
                        this.$router.push('/competitionDetails');
                      }else{
                        localStorage.removeItem('competitionIdToView');
                        this.$router.push('/home');
                      }

                    }

                } catch (error) {
                    console.error('Error al guardar trucos validados:', error);
                }

            }
        },
        async updateScoreList() {
            const isConfirmed = await this.confirmWithModal('Are you sure you want to update the round?');
            if (isConfirmed) {
                try {
                  this.showLoading();
                    const response = await this.$axios.post(`/update_round`, {
                        modeProgram: this.modeProgram,
                        validatedTricks: this.validatedTricks,
                        totalScorePrint: this.totalScorePrint,
                        countUniqueTrick: this.countUniqueTrick.total,
                        totalScore: this.totalScore,
                        roundId: this.$store.state.roundIdToUpdate,
                        videoUrl: this.videoUrl,
                    }, {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.getToken}`,
                        },
                    });
                    if (response.status === 200){
                        this.validatedTricks = [];
                        this.selectedListTricks = [];
                        this.comboSelected = [];
                        this.comboCount = 1;
                        this.totalScorePrint = {
                            'style' : '0%',
                            'score' : 0,
                        };
                        localStorage.removeItem('validatedTricks');
                        localStorage.removeItem('selectedTricks');
                        localStorage.removeItem('comboCount');
                        localStorage.removeItem('videoUrl');

                        this.$emit('clear-validated-tricks');
                        this.hideLoading();
                        this.$store.commit('resetRoundIdToUpdate');
                        this.round_update = false;
                      if (this.$store.state.competitionIdToView != null){
                        this.$router.push('/competitionDetails');
                      }else{
                        localStorage.removeItem('competitionIdToView');
                        this.$router.push('/home');
                      }
                    }
                } catch (error) {
                    console.error('Error al guardar trucos validados:', error);
                }
            }
        },
        handleConfirmed() {
            if (!this.pendingConfirmResolver) {
                return;
            }

            const resolve = this.pendingConfirmResolver;
            this.resetConfirmationModalState();
            resolve(true);
        },
        cancelModal() {
            if (!this.pendingConfirmResolver) {
                this.resetConfirmationModalState();
                return;
            }

            const resolve = this.pendingConfirmResolver;
            this.resetConfirmationModalState();
            resolve(false);
        },
        resetConfirmationModalState() {
            this.pendingConfirmResolver = null;
            this.showCancel = false;
            this.modalMessage = "";
        },
        confirmWithModal(message) {
            return new Promise((resolve) => {
                this.pendingConfirmResolver = resolve;
                this.showCancel = true;
                this.modalMessage = message;
                this.$refs.confirmationModal.openModal();
            });
        },
        async editRound(roundId) {

            try {
                this.showLoading();
                const response = await this.$axios.get(`/get_round/${roundId}`, {
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                });
                if (response.status === 200){
                    this.selectedListTricks = [];
                    this.comboSelected = [];
                    this.comboCount = 1;
                    localStorage.removeItem('selectedTricks');
                    localStorage.removeItem('comboCount');
                    localStorage.removeItem('videoUrl');
                    this.validatedTricks = response.data.validatedTricks;
                    this.videoUrl = response.data.round.video_link;
                    this.modeProgram = response.data.round.rule_id;
                    await this.syncTricklistForContext({ round: response.data.round });
                    secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
                    secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
                  // this.adjustContentHeight();
                  this.hideLoading();
                }

            } catch (error) {
                console.error('Error al guardar trucos validados:', error);
                console.log('Detalles del error:', error.response);
            }

        },
        async viewRound(roundId) {

            try {
                this.showLoading();
                const response = await this.$axios.get(`/get_round/${roundId}`, {
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                });
                if (response.status === 200){
                    this.selectedListTricks = [];
                    this.comboSelected = [];
                    this.comboCount = 1;
                    localStorage.removeItem('selectedTricks');
                    localStorage.removeItem('comboCount');
                    localStorage.removeItem('videoUrl');
                    this.validatedTricks = response.data.validatedTricks;
                    this.videoUrl = response.data.round.video_link;
                    this.modeProgram = response.data.round.rule_id;
                    await this.syncTricklistForContext({ round: response.data.round });
                    secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
                    secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
                    // this.adjustContentHeight();
                  this.hideLoading();
                }

            } catch (error) {
                console.error('Error al guardar trucos validados:', error);
                console.log('Detalles del error:', error.response);
            }

        },
        deleteVideoUrlComponent(){
            this.videoUrl = null;
            localStorage.removeItem('videoUrl');
        },
      async checkName(athleteId) {

        try {
          this.showLoading();
          const response = await this.$axios.get(`/check_name/${athleteId}`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getToken}`,
            },
          });
          if (response.status === 200){
            this.athleteFullName = response.data.user;
            this.hideLoading();
          }

        } catch (error) {
          console.error('Error al guardar trucos validados:', error);
          console.log('Detalles del error:', error.response);
        }

      },
      async fetchCompetitionDetails(competitionId) {
        this.showLoading();
        try {
          const response = await this.$axios.get(`/competition/${competitionId}`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getToken}`,
            },
          });
          this.competitionDetails = response.data.competition;
          this.modeProgram = this.competitionDetails.rule_id;
                  await this.syncTricklistForContext({ competitionId });
          console.log(this.competitionDetails);
          console.log('El athelta: ' + this.athleteId);
          // this.isExpanded[7] = true;
          this.hideLoading();
        } catch (error) {
          console.error('Error al obtener las rondas:', error);
        }
      },
      findLastRound() {
          console.log(this.competitionDetails);
        console.log('El athelta2: ' + this.athleteId);
        if (this.competitionDetails && this.competitionDetails.rounds && this.competitionDetails.rounds.length) {
          const roundsForAthlete = this.competitionDetails.rounds.filter(round => round.user_id === this.athleteId);
          if (roundsForAthlete.length) {
            this.lastRound = roundsForAthlete[roundsForAthlete.length - 1]; // Último round coincidente
          } else {
            this.lastRound = null;
          }
        } else {
          this.lastRound = null;
        }
      },
        /*Video_BOx*/
      adjustContentHeight() {
        const isMobileOrTablet = window.innerWidth <= 768;

        if (isMobileOrTablet) {
          // Restablecer estilos para dispositivos móviles o tablets
          this.$refs.scrollableContent.style.marginTop = '0';
          this.$refs.scrollableContent.style.height = 'auto';
        } else {
          // Aplicar cálculos de altura para pantallas más grandes
          const fixedVideoBoxHeight = this.$refs.fixedVideoBox.clientHeight;
          const navbarHeight = 60; // Altura de la navbar
          this.$refs.scrollableContent.style.marginTop = `${fixedVideoBoxHeight}px`;
          const scrollableContentHeight = window.innerHeight - (fixedVideoBoxHeight + navbarHeight);
          this.$refs.scrollableContent.style.height = `${scrollableContentHeight}px`;
        }
      },

      saveVideoLink() {
            this.videoUrl = this.videoLink;
            secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
        },
        /*Utils for Counters*/
       async getTrickListUpdated(){
            await this.syncTricklistForContext({ force: true });
        },
        getTricklistHintVersionId(round = null) {
            return round?.effective_tricklist_version_id
                || round?.tricklist_version?.id
                || this.competitionDetails?.tricklist_version_id
                || this.competitionDetails?.tricklist_version?.id
                || null;
        },
        async syncTricklistForContext({ round = null, competitionId = null, force = false } = {}) {
            const hintedVersionId = this.getTricklistHintVersionId(round);
            const requestParams = round?.id
                ? { round_id: round.id }
                : (competitionId || this.competitionDetails?.id)
                    ? { competition_id: competitionId || this.competitionDetails.id }
                    : null;

            if (!force && hintedVersionId && hintedVersionId === this.activeTricklistVersionId && Array.isArray(this.tricks) && this.tricks.length) {
                return;
            }

            if (!force && hintedVersionId) {
                const cached = readCachedTricklist(secureStorage, hintedVersionId);
                if (cached.length) {
                    this.tricks = cached;
                    this.activeTricklistVersionId = hintedVersionId;
                    return;
                }
            }

            if (!requestParams) {
                return;
            }

            try {
                const response = await this.$axios.get('/tricks', {
                    params: requestParams,
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                });

                if (response.status !== 200) {
                    return;
                }

                const normalizedTricks = normalizeTricklistEntries(response.data?.tricks || []);
                const resolvedVersionId = response.data?.tricklist_version_id ?? hintedVersionId ?? null;

                this.tricks = normalizedTricks;
                this.activeTricklistVersionId = resolvedVersionId;
                writeCachedTricklist(secureStorage, resolvedVersionId, normalizedTricks);
            } catch (error) {
                console.error('Error al descargar Tricklist:', error);
                console.log('Detalles del error:', error.response);
            }
        },
        getKeyForTrick(trick) {
            if (trick.id !== undefined) {
                return trick.id + (trick.variation ? ` - ${trick.variation}` : '') + (trick.grab ? ` - ${trick.grab}` : '');
            } else {
                return undefined;
            }
        },
        getCountCombos(){
            let counterId = JSON.parse(localStorage.getItem('comboCount')) || 1;
            const countTricks = (singleTrick) => {
                singleTrick.forEach(currentTrick => {
                    if (Array.isArray(currentTrick.body) && currentTrick.body.length > 0) {
                        counterId = currentTrick.header.combo_id + 1;
                    }
                });
            };
            countTricks(this.validatedTricks);
            this.comboCount = counterId;
            localStorage.setItem('comboCount', JSON.parse(this.comboCount));
        },
        scrollToElement(element){
            const elementToScroll = document.getElementById(element);
            if (elementToScroll) {
                const scrollOptions = {
                    behavior: 'smooth',
                };
                const elementPosition = elementToScroll.getBoundingClientRect();
                window.scrollTo({
                    top: window.scrollY + elementPosition.top,
                    ...scrollOptions,
                });
            }

        },
        showLoading() {
            this.$nextTick(() => {
                this.$refs.loadingModal.showLoading();
            });
        },
        hideLoading() {
            this.$nextTick(() => {
                this.$refs.loadingModal.hideLoading();
            });
        },
        toggleCollapse() {
          // Cambiar el estado de expansión al hacer clic en el botón
          this.isExpanded = !this.isExpanded;
          // if (!this.isExpanded) {
          //   this.$nextTick(() => {
          //     this.adjustContentHeight();
          //   });
          // }
        },

      beforeEnter(el) {
            el.style.opacity = 0;
        },
        enter(el, done) {
            el.offsetHeight; // Activa el reflujo
            el.style.transition = "opacity 0.5s";
            el.style.opacity = 1;
            done();
        },
        leave(el, done) {
            el.style.transition = "opacity 0.2s";
            el.style.opacity = 0;
            done();
        },
        /*Scoring*/
        calculateTotalWithRules() {
            const rulesApplyToScore_1 = () => {
                return this.calculateWithOutRules();
            };
            const rulesApplyToScore_2 = () => {
                this.getCountCombos();
                this.calculateRepetitionsTricks();
                this.calculateDubsTricks();
                this.calculateTotalCombo();
                this.calculateTotalComboNow();
                this.calculateVarietyPlus();
                return this.calculateStyleRound();
            };
            const rulesApplyToScore_3 = () => {
                this.getCountCombos();
                this.calculateRepetitionsTricks();
                this.calculateDubsTricks();
                this.calculateTotalComboPlus();
                this.calculateTotalComboNow();
                this.calculateVarietyPlus();
                return this.calculateStyleRound();
            };
             const rulesApplyToScore_4 = () => {
                this.getCountCombos();
                this.calculateRepetitionsTricks();
                this.calculateDubsTricks();
                this.calculateTotalCombo_10();
                this.calculateTotalComboLevel();
                this.calculateTotalComboAirLevel()
                this.calculateTotalComboNow();
                this.calculateVarietyPlus();
                return this.calculateStyleRound();
            };

            switch (true) {
                case this.modeProgram === 1:
                    return rulesApplyToScore_1();
                case this.modeProgram === 2:
                    return rulesApplyToScore_2();
                case this.modeProgram === 3:
                    return rulesApplyToScore_3();
                case this.modeProgram === 4:
                    return rulesApplyToScore_4();
                default:
                    console.error('Modo no reconocido:', this.modeProgram);
                    return this.totalScore;
            }
        },
        /*NOT Rules*/
        calculateWithOutRules(){
            this.totalScorePrint.style = '0%';
            this.totalScorePrint.score = this.totalScore;
        },
        /*Basics*/
        calculateRepetitionsTricks() {
            const trickCounts = new Map();
            const countTricks = (singleTrick) => {
                singleTrick.forEach(currentTrick => {
                    const key = this.getKeyForTrick(currentTrick);
                    if (key !== undefined) {
                        if (!trickCounts.has(key)) {
                            trickCounts.set(key, { count: 1, trick: currentTrick });
                            this.resetScoreValue(currentTrick);
                        } else {
                            trickCounts.get(key).count += 1;
                            this.handleRepetitionCount(currentTrick,trickCounts.get(key).count);
                        }
                    }
                    if (Array.isArray(currentTrick.body)) {
                        countTricks(currentTrick.body);
                    }
                });
            };
            return countTricks(this.validatedTricks);
        },
        handleRepetitionCount(currentTrick,count){
            if (count === 2) {
                currentTrick.score = currentTrick.value * SCORING_LESS_25;
            } else if (count === 3) {
                currentTrick.score = currentTrick.value * SCORING_LESS_50;
            } else {
                currentTrick.score = currentTrick.value * SCORING_LESS_75;
            }
        },
        resetScoreValue(currentTrick){
            currentTrick.score = currentTrick.value;
        },
        calculateDubsTricks() {
            const dubTricks = (singleTrick) => {
                singleTrick.forEach(currentTrick => {
                    if (currentTrick.dub === 1) {
                        currentTrick.score *= SCORING_DUB_20;
                    } else if (currentTrick.dub === 2) {
                        currentTrick.score *= SCORING_DUB_50;
                    } else if (currentTrick.dub > 2) {
                        currentTrick.score *= SCORING_DUB_80;
                    }
                    if (Array.isArray(currentTrick.body)) {
                        dubTricks(currentTrick.body);
                    }
                });
            };
            return dubTricks(this.validatedTricks);
        },
        /*TJS 3.2*/
        calculateTotalCombo() {
            const calculateScore = (tricks) => {
                tricks.forEach((trick) => {
                    if (Array.isArray(trick.body)) {
                        let longSelected = trick.body.length || 0;
                        if (longSelected){
                            switch (true) {
                                case longSelected === 1:
                                    break;
                                case longSelected >= 2 && longSelected <= 5:
                                    trick.body.forEach((trick) => {
                                        trick.score *=SCORING_COMBO_PLUS;
                                    });
                                    break;
                                case longSelected >= 6:
                                    trick.body.forEach((trick) => {
                                        trick.score *= SCORING_COMBO_PLUS_6;
                                    });
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                });
                return 0;
            };
            return calculateScore(this.validatedTricks);
        },
        calculateTotalComboPlus() {
            const calculateScore = (tricks) => {
                tricks.forEach((trick) => {
                    if (Array.isArray(trick.body)) {
                        let longSelected = trick.body.length || 0;
                        if (longSelected){
                            let lastCombo = trick.body[longSelected - 1];
                            let isTypeOne = lastCombo.type === 1;
                            if (isTypeOne){
                                switch (true) {
                                    case longSelected === 1:
                                        break;
                                    case longSelected >= 2 && longSelected <= 5 && isTypeOne:
                                        trick.body.forEach((trick) => {
                                            trick.score *= SCORING_COMBO_PLUS_FEET;
                                        });
                                        break;
                                    case longSelected >= 6 && isTypeOne:
                                        trick.body.forEach((trick) => {
                                            trick.score *= SCORING_COMBO_PLUS_6_FEET;
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            }else{
                                switch (true) {
                                    case longSelected === 1:
                                        break;
                                    case longSelected >= 2 && longSelected <= 5:
                                        trick.body.forEach((trick) => {
                                            trick.score *=SCORING_COMBO_PLUS;
                                        });
                                        break;
                                    case longSelected >= 6:
                                        trick.body.forEach((trick) => {
                                            trick.score *= SCORING_COMBO_PLUS_6;
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            }

                        }
                    }
                });
                return 0;
            };
            return calculateScore(this.validatedTricks);
        },
        calculateTotalComboNow() {
            const calculateScore = (tricks) => {
                tricks.forEach((trick) => {
                    if (Array.isArray(trick.body)) {
                        trick.body.reduce((subTotal, subTrick) => {
                            trick.header.total_score = subTotal + (subTrick.score || 0);
                            return subTotal + (subTrick.score || 0);
                        }, 0);
                    }
                });
                return 0;
            };
            return calculateScore(this.validatedTricks);

        },
        calculateVarietyPlus(){
            const trickCounts = new Map()
            const totalReturn = {
                'details' :trickCounts,
                'total' : 0
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    const key = this.getKeyForTrick(trick);
                    if (key !== undefined) {
                        trickCounts.set(key, (trickCounts.get(key) || 0) + 1);
                    }
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }
                });
            };
            countTricks(this.validatedTricks);
            totalReturn.total = trickCounts.size;
            return totalReturn.total;
        },
        calculateStyleRound() {
            let grabCount = 0;
            const countTricks = (tricks) => {
                tricks.forEach((currentTrick) => {
                    if (currentTrick.grab) {
                        grabCount++;
                    }
                    if (Array.isArray(currentTrick.body)) {
                        countTricks(currentTrick.body);
                    }
                });
            };

            countTricks(this.validatedTricks);

            switch (true) {
                case grabCount === 1:
                    this.totalScorePrint.style = '5%';
                    this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_1) + this.calculateVarietyPlus();
                    break;
                case grabCount >=2 && grabCount <= 3:
                    this.totalScorePrint.style = '10%';
                    this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_2) + this.calculateVarietyPlus();
                    break;
                case grabCount >=4 && grabCount <= 6:
                    this.totalScorePrint.style = '15%';
                    this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_4) + this.calculateVarietyPlus();
                    break;
                case grabCount >= 7:
                    this.totalScorePrint.style = '20%';
                    this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_7) + this.calculateVarietyPlus();
                    break;
                default:
                    this.totalScorePrint.style = '0%';
                    this.totalScorePrint.score = this.totalScore + this.calculateVarietyPlus();
                    break;
            }
            return this.totalScorePrint;
        },
        /*TJS 4.0*/
        calculateTotalCombo_10() {
            const calculateScore = (tricks) => {
                tricks.forEach((trick) => {
                    if (Array.isArray(trick.body)) {
                        let longSelected = trick.body.length || 0;
                        if (longSelected > 0) {
                            trick.body.forEach((trick, index) => {
                                const multiplier = 1 + 0.02 * (index + 1);
                                trick.score *= multiplier;
                            });
                        }
                    }
                });
                return 0;
            };
            return calculateScore(this.validatedTricks);
        },
        calculateTotalComboLevel() {
          const comboSame = [];
          const comboBalanced = [];
          const comboMixto = [];

          this.validatedTricks.forEach((trick) => {
            if (trick && trick.header && Array.isArray(trick.body) && trick.body.length > 0) {
              const comboId = trick.header.combo_id;

              const sameLevel = trick.body.every(item => item.level === trick.body[0].level);

              if (sameLevel) {
                comboSame.push(comboId);
              } else {
                const counts = trick.body.reduce((acc, item) => {
                  acc[item.level] = (acc[item.level] || 0) + 1;
                  return acc;
                }, {});

                const totalTricks = trick.body.length;
                const expectedCount = totalTricks / 4;

                const isBalanced = Object.values(counts).every(count => count === expectedCount);

                if (isBalanced) {
                  comboBalanced.push(comboId);
                } else {
                  comboMixto.push(comboId);
                }
              }
            }
          });

          if (comboSame.length > 0) {
            console.log(`Se encontraron combos del mismo nivel con IDs: ${comboSame.join(', ')}`);
            comboSame.forEach((comboId) => {
              const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
              if (combo) {
                combo.body.forEach((trick) => {
                  switch (trick.level) {
                    case 1:
                      trick.score *= 1.05;
                      break;
                    case 2:
                      trick.score *= 1.10;
                      break;
                    case 3:
                      trick.score *= 1.15;
                      break;
                    case 4:
                      trick.score *= 1.20;
                      break;
                    default:
                      break;
                  }
                });
              }
            });
          }
          if (comboBalanced.length > 0) {
            console.log(`Se encontraron combos balanceados con IDs: ${comboBalanced.join(', ')}`);
            comboBalanced.forEach((comboId) => {
              const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
              if (combo) {
                combo.body.forEach((trick) => {
                  trick.score *= 1.125;
                });
              }
            });
          }
          if (comboMixto.length > 0) {
            console.log(`Se encontraron combos mixtos con IDs: ${comboMixto.join(', ')}`);
            comboMixto.forEach((comboId) => {
              const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
              if (combo) {
                // Inicializar un objeto para contar trucos por nivel
                const counts = { 1: 0, 2: 0, 3: 0, 4: 0 };

                // Contar trucos por nivel
                combo.body.forEach((trick) => {
                  counts[trick.level]++;
                });

                // Imprimir la cantidad de trucos por nivel
                console.log('Cantidad de trucos por nivel:');
                Object.keys(counts).forEach((level) => {
                  console.log(`Nivel ${level}: ${counts[level]}`);
                });

                // Imprimir la puntuación de cada truco junto con la cantidad de trucos por nivel
                console.log('Puntuación de trucos y cantidad por nivel:');
                combo.body.forEach((trick) => {
                  let porcentLevel = ((counts[1]/combo.body.length)*0.05)*100 + ((counts[2]/combo.body.length)*0.10)*100 + ((counts[3]/combo.body.length)*0.15)*100 + ((counts[4]/combo.body.length)*0.20)*100;
                  trick.score *= (1+(porcentLevel/100));
                });
              }
            });
          }

          if (comboSame.length === 0 && comboBalanced.length === 0 && comboMixto.length === 0) {
            console.log("No se encontró ningún combo balanceado ni mixto ni iguales");
          }

          return 0;
        },
        calculateTotalComboAirLevel() {
              const calculateScore = (tricks) => {
                  tricks.forEach((trick) => {
                      if (Array.isArray(trick.body)) {
                          let longSelected = trick.body.length || 0;
                          if (longSelected){
                              let lastCombo = trick.body[longSelected - 1];
                              let isTypeOne = lastCombo.type === 1;
                              if (isTypeOne){
                                  switch (lastCombo.level) {
                                      case 1:
                                          trick.body.forEach((trick) => {
                                              trick.score *= 1.10;
                                          });
                                          break;
                                      case 2:
                                          trick.body.forEach((trick) => {
                                              trick.score *= 1.15;
                                          });
                                          break;
                                      case 3:
                                          trick.body.forEach((trick) => {
                                              trick.score *= 1.20;
                                          });
                                          break;
                                      case 4:
                                          trick.body.forEach((trick) => {
                                              trick.score *= 1.30;
                                          });
                                          break;
                                      default:
                                          break;
                                  }
                              }

                          }
                      }
                  });
                  return 0;
              };
              return calculateScore(this.validatedTricks);
          },



        /*Tutorial*/

    }
};
</script>

<style scoped>

.box_component {
    width: 100%;
    max-width: 100%;
    margin: 15px auto;
}
/*.judging-program-view {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.fixed-video-box {
  position: fixed;
  top: auto;
  left: 0;
  right: 0;
  z-index: 1000;
}*/

.scrollable-content {
  overflow-y: auto;
}

@media (max-width: 768px) {
  /*.judging-program-view {
    overflow: auto;
  }

  .fixed-video-box {
    position: static; !* Cambia a static para eliminar el posicionamiento fijo *!
    top: auto;
    left: auto;
    right: auto;
    z-index: auto; !* Restablece el z-index si es necesario *!
  }

  .scrollable-content {
    padding-left: 0;
    position: static; !* Asegúrate de que también esté estático si tenía otra posición *!
  }*/
}




/*ScoringBox*/
.bar-item {
    flex: 1 1 50%;
    padding: 10px;
    box-sizing: border-box;
}
.total-bar,.total-style-bar,.total-variety-bar,.total-score-bar {
    background-color: rgba(76, 175, 80, 0.97);
    color: #000;
    padding: 8px;
    text-align: center;
    border-radius: 4px;
    margin-top: 10px;
    transition: background-color 0.3s, color 0.3s;
}
.total-style-bar {
    background-color: rgba(168, 151, 99, 0.4);
}
.total-variety-bar {
    background-color: rgba(73, 69, 46, 0.4);
}
.total-score-bar {
    background-color: rgb(203, 169, 74);
}
.clear-btn {
    width: 100%;
    background-color: #ff4d4d;
    color: white;
    padding: 6px 10px;
    border: none;
    border-radius: 4px;
    margin-top: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}
.clear-btn:hover {
    background-color: #cc0000;
}
</style>